import type { FC } from 'react';
import React from 'react';

import type { IconColor } from '@atlaskit/tokens/css-type-schema';

import { List24Icon } from './images/List24Icon.tsx';

type ListIconProps = {
	label: string;
	primaryColor?: IconColor;
	testId?: string;
};

export const ListIcon: FC<ListIconProps> = ({ label, primaryColor, testId }) => {
	return React.createElement(List24Icon, {
		label,
		testId,
		primaryColor,
	});
};
